export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8142.390ef5c5.jpg";